import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
import Modal from '../../components/modal';
import NewAddressModal from './newaddressmodal';
import EditAddressModal from './editaddressmodal';
import WhitelistModal from './whitelistmodal';

import {
  fetchSecurity,
  fetchAddresses,
  addNewAddress,
  updateAddress,
  deleteAddress,
  enableAddressbookWhitelist,
  disableAddressbookWhitelist,
} from '../../actions';

const dateFormat = 'L LT';

class AddressBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalComponent: null,
      wideModal: true,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchSecurity());
    dispatch(fetchAddresses());
  }

  toggleModal(component, wideModal) {
    this.setState({
      modalComponent: component,
      wideModal: wideModal,
    });
  }

  render() {
    const { addressbook, errors, success, user } = this.props;
    let tableLoop = <tr><td colSpan="4" className="no-data text-center">No Data</td></tr>;
    let tableData;
    if (addressbook && addressbook.data && addressbook.data.length) {
      tableData = addressbook.data;
    }

    if (tableData) {
      tableLoop = tableData.map((item, index) => {
        return (
          <tr key={index} className="text-transform-none">
            <td>{item.typeHandle || ''}</td>
            <td>{item.nickname || ''}</td>
            <td>{item.address || ''}</td>
            <td>{item.tag || ''}</td>
            {/* <td>{moment.unix(item.createdAt).format(dateFormat) || ''}</td> */}
          </tr>
        );
      });
    }

    const whitelistEnabled = user && user.me && user.me.flags && user.me.flags.addressbookWhitelist;

    let otpEnabled;
    let yubiEnabled;

    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    const tfaEnabled = otpEnabled || yubiEnabled;

    return (
      <div className="grid-x addressbook">
        <ToastHandler errors={errors} success={success} />
        {this.state.modalComponent && (
          <Modal
            toggleModal={this.toggleModal}
            modalComponent={this.state.modalComponent}
            wideModal={this.state.wideModal}
          />
        )}
        <div className="cell panel">
          <div className="panel-ta-con">
            <div className="panel-label">
              Addresses
            </div>
            <div className="p-ta-con">
              Whitelist:
              <div
                onClick={() => this.toggleModal(<WhitelistModal toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} whitelistEnabled={whitelistEnabled} />, false)}
                className={whitelistEnabled ? 'vlt-switch--sm on' : 'vlt-switch--sm off'}
              >
              </div>
            </div>
          </div>
          <table>
            <colgroup>
              <col style={{width: '15%'}}></col>
              <col style={{width: '30%'}}></col>
              <col style={{width: '40%'}}></col>
              <col style={{width: '15%'}}></col>
            </colgroup>
            <thead>
              <tr>
                <th>Asset</th>
                <th>Nickname</th>
                <th>Address</th>
                <th>Tag</th>
                {/* <th>Date Added</th> */}
              </tr>
            </thead>
            <tbody className="lt-body">
              {tableLoop}
            </tbody>
          </table>
          <div className="button-area" style={{marginTop: '24px'}}>
            { tableData && tableData.length ? (
              <button className="vlt-button dark-b" onClick={() => this.toggleModal(<EditAddressModal toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />, true)} disabled={!tfaEnabled}>
                <span>
                  Edit
                </span>
              </button>
            ) : (
              null
            )}
            <button className="vlt-button dark-b" onClick={() => this.toggleModal(<NewAddressModal toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />, true)} disabled={!tfaEnabled}>
              <span>
                Add New
              </span>
            </button>
          </div>
          {tfaEnabled ? null : (
            <p className="pt-neg text-right" style={{marginBottom: '0px'}}>
              2FA must be enabled
            </p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.addressbook.errors,
  success: state.addressbook.success,
  addressbook: state.addressbook.addressbook,
});

export default connect(mapStateToProps)(AddressBook);
